import { render, staticRenderFns } from "./MapIconSportWegym.vue?vue&type=template&id=0854435e&scoped=true&"
import script from "./MapIconSportWegym.vue?vue&type=script&lang=js&"
export * from "./MapIconSportWegym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854435e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0854435e')) {
      api.createRecord('0854435e', component.options)
    } else {
      api.reload('0854435e', component.options)
    }
    module.hot.accept("./MapIconSportWegym.vue?vue&type=template&id=0854435e&scoped=true&", function () {
      api.rerender('0854435e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconSportWegym.vue"
export default component.exports